export default __webpack_public_path__ + "static/media/T500_28A500A.ec0e42e7.STEP";